export default {
    INTERNAL_USER_ACCESS: "INTERNAL_USER_ACCESS",
    NEWS_EDIT: "NEWS_EDIT",
    SURVEY_EDIT: "SURVEY_EDIT",
};
